import { HttpClient, HttpContextToken, HttpRequest, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { HttpErrorService } from '../http-error.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, delay, filter, map, toArray } from 'rxjs/operators';
import { concat, of } from 'rxjs';
import { Device } from 'src/app/app.types';
import { GENERIC_ERROR_SUPPRESSION_TOKEN } from 'src/app/app.module';

@Injectable({
  providedIn: 'root'
})
export class LogsRequestsService {
  /**
   * CTOR
   * @param {HttpClient} http
   * @param {ConfigService} configService
   * @param {HttpErrorService} httpErrorService
   */
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private httpErrorService: HttpErrorService,
    private toastrService: ToastrService,
    @Inject(GENERIC_ERROR_SUPPRESSION_TOKEN) private suppressGenericErrorToken: HttpContextToken<boolean>
  ) {}

  requestManyLogs(deviceIds: string[]) {
      const url = this.configService.API_URI + '/LogsRequests/RequestMany';
      const req = new HttpRequest('POST', url, deviceIds);
  
      return this.http.request(req).pipe(
        map((res) => {
          if (res instanceof HttpResponse) {
            this.toastrService.success('Request for device logs successfully sent.', 'Success');
            return res;
          }
        }),
        catchError((err) => {
          this.httpErrorService.handleHttpError(err);
          return of(err);
        })
      );
  }

  download(devices: Device[]) {
      const downloadObs = devices.filter(x => x.logsRequest)
        .map(device => {
        const url = this.configService.API_URI + `/LogsRequests/Download/${device.id}`;
        const req = new HttpRequest('GET', url, { responseType: 'blob' });

        req.context.set(this.suppressGenericErrorToken, true);

        return this.http.request(req).pipe(
          delay(500),
          filter(res => res instanceof HttpResponseBase),
          map((res : any) => {
            if (res.status == 200) {
              this.downloadFromResponse(res, device.serialNumber);

              return { serialNo: device.serialNumber, success: true };
              
            } else {
              return { serialNo: device.serialNumber, success: false };
            }
          }),
          catchError((err) => {
            console.log(err);
            return of({ serialNo: device.serialNumber, success: false });
          })
        );
      });

      return concat(...downloadObs).pipe(
        toArray(), 
        map(deviceInfos => {
          if(deviceInfos.every(y => y.success)) {
            this.toastrService.success('Download logs successful', 'Success');
          } else if(deviceInfos.every(y => !y.success)) {
            this.toastrService.error('Download logs  unsuccessful.', 'Error');
          } else {
            this.toastrService.warning(`One or more downloads were not successful.`, 'Information');
          }
        }));
  }

  downloadFromResponse(res: any, serialNo: string): void {
    const downloadLink = document.createElement("a");
    downloadLink.onclick = (x: any) => {
        document.body.removeChild(x.target);
    };
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.download = `logs_${serialNo}.zip`;
    downloadLink.href = URL.createObjectURL(res.body);
    downloadLink.click();
  }
}
